//

import { normalize } from 'normalizr';
import { browserHistory } from 'react-router';

import { project } from './schemas';
import { simplApi } from '../../api/simplApi';

import { receiveActivity } from './activity';
// import { receiveCompany } from './company';
import { receiveFile } from './file';
import { fetchTotalData } from './totaldata';
import handleApiError from '../../helpers/handleApiError';
import { addFeedback } from './feedback';
// import { receivePerson } from './person';
// import { receiveStaff } from './staff';

const _ = require('lodash');

// ------------------------------------
// Constants
// ------------------------------------
export const REQUEST_PROJECT = 'REQUEST_PROJECT';
export const RECEIVE_PROJECT = 'RECEIVE_PROJECT';
export const SET_PROJECT = 'SET_PROJECT';
export const SET_PROJECT_FORM = 'SET_PROJECT_FORM';
export const CLOSE_PROJECT_FORM = 'CLOSE_PROJECT_FORM';
export const REMOVE_PROJECT = 'REMOVE_PROJECT';

// ------------------------------------
// Actions
// ------------------------------------

export function requestProject() {
  return {
    type: REQUEST_PROJECT,
  };
}

export function receiveProject(projects) {
  return {
    type: RECEIVE_PROJECT,
    payload: {
      projects,
    },
  };
}

export function setProject(projectId) {
  return {
    type: SET_PROJECT,
    payload: projectId,
  };
}

export function setProjectForm(projectId = 0) {
  return {
    type: SET_PROJECT_FORM,
    payload: projectId,
  };
}

export function closeProjectForm() {
  return {
    type: CLOSE_PROJECT_FORM,
  };
}

export const fetchProject = projectId => dispatch => {
  dispatch(requestProject());

  const url =
    typeof projectId !== 'undefined' && projectId !== null
      ? `project/${projectId}`
      : 'project';

  simplApi(url)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        if (__DEV__) {
          // console.log('error!');
        }

        dispatch(handleApiError(json));
      } else {
        let preparedProjects;

        if (typeof json.id === 'undefined') {
          preparedProjects = normalize(json, [project]);
        } else {
          preparedProjects = normalize(json, project);
        }

        // // console.log(preparedProjects)
        dispatch(receiveProject(preparedProjects.entities.projects));
        dispatch(receiveActivity(preparedProjects.entities.activities));
        // dispatch(receiveCompany(preparedProjects.entities.companies))
        dispatch(receiveFile(preparedProjects.entities.files));
        // dispatch(receiveStaff(preparedProjects.entities.staffs))
        // dispatch(receivePerson(preparedProjects.entities.persons))
      }
    });
};

export function removeProject(projectId) {
  return {
    type: REMOVE_PROJECT,
    payload: projectId,
  };
}

export const deleteProject = projectId => dispatch => {
  const url = `project/${projectId}`;
  const options = { method: 'delete' };

  simplApi(url, options)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        if (__DEV__) {
          // console.log('error!');
        }

        dispatch(handleApiError(json));
      } else {
        dispatch(removeProject(projectId));
        dispatch(addFeedback('warning', 'Projekt gelöscht'));
      }
    });
};

export const saveProject = newProject => dispatch => {
  // console.log('attempting to save a project!');

  dispatch(requestProject());

  let url = 'project/';
  const options = { method: 'post', body: newProject };
  if (typeof newProject.id !== 'undefined' && newProject.id !== null) {
    url = `${url}${newProject.id}`;
    options.method = 'put';
  }

  simplApi(url, options)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        if (__DEV__) {
          // console.log('error!');
        }

        dispatch(handleApiError(json));
      } else {
        const preparedProjects = normalize(json, project);

        dispatch(receiveProject(preparedProjects.entities.projects));
        dispatch(receiveFile(preparedProjects.entities.files));

        dispatch(fetchTotalData());

        dispatch(addFeedback('success', 'Projekt gespeichert'));

        browserHistory.push(`/project/${json.id}`);
      }
    });
};

export const actions = {
  requestProject,
  receiveProject,
  setProject,
  setProjectForm,
  closeProjectForm,
  fetchProject,
  saveProject,
  deleteProject,
  removeProject,
};

const PROJECT_ACTION_HANDLERS = {
  [REQUEST_PROJECT]: state => ({
    ...state,
    fetching: true,
  }),
  [SET_PROJECT]: (state, action) => ({ ...state, current: action.payload }),
  [SET_PROJECT_FORM]: (
    state,
    action,
    // console.log('firing action:', action);
  ) => ({ ...state, formOpen: true, formTarget: action.payload }),
  [REMOVE_PROJECT]: (state, action) => ({
    ...state,
    projects: _.omit(state.projects, action.payload),
  }),
  [CLOSE_PROJECT_FORM]: state => ({
    ...state,
    formOpen: false,
    formTarget: null,
  }),
  [RECEIVE_PROJECT]: (state, action) => {
    const stateProjects = state.projects;

    _.forOwn(action.payload.projects, (_project, id) => {
      const newProject = _project;

      if (typeof stateProjects[id] === 'object') {
        Object.assign(stateProjects[id], stateProjects[id], newProject);
      } else {
        stateProjects[id] = newProject;
      }
    });

    return {
      ...state,
      projects: stateProjects,
      fetching: false,
    };
  },
};

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = {
  fetching: false,
  current: null,
  formOpen: false,
  formTarget: null,
  projects: {},
};
export default function projectReducer(state = initialState, action) {
  const handler = PROJECT_ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/store/modules/project.js